export default __webpack_public_path__ + "static/media/globe.a8e16612.svg";